const React = require('react');
const KeyboardDatePickerBase = require('./Base');


module.exports = ({
  className,
  helperText,
  ...props
}) => {
  return (<KeyboardDatePickerBase
    {...props}
    picker={{
      className: `
o50>.MuiInputBase-input.Mui-disabled w
(pv9|ph25|hmin45|bxzBB|fw3|ff$3)>.MuiOutlinedInput-input
(dn|f14|ov|r8)>.MuiOutlinedInput-root
(f12|ff$3|fw3|ph5|bgF|x20y16s100|c0:not[.*-error]!)>.MuiInputLabel-outlined*2
(x20y-6s100)>.MuiInputLabel-outlined.Mui(FormLabel-filled|-focused)*2
pr>.*-adornedEnd
st-4.5>fieldset
(dn|b1|bc0)>fieldset*2
bc0(:h>*|>.Mui-focused):not[.Mui-error]>fieldset*2
b1>.Mui-focused>fieldset*2
dN>.MuiFormHelperText-root
dN>legend>span
c0>.MuiIconButton-root
      `,
    }}
    after={props.error ? (<div className="rlv">
      <div
        className="abs sh25 st f11 cF00 fw4"
      >{helperText || 'Date is invalid'}</div>
    </div>) : null}
  />);
};
